var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V24H32V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_270_66157",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V24H32V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_270_66157)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V8H32V0H0Z",
    fill: "#BF2714"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16V24H32V16H0Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2603 10.2202L13.2593 10.266L13.0085 15.7358L12.0096 15.69L12.2603 10.2202Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3041 10.5597L14.3025 10.6162L14.0517 15.0515L13.0533 14.9951L13.3041 10.5597Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3484 10.8919L15.3451 10.9737L15.0943 14.0297L14.0977 13.9479L14.3484 10.8919Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7397 10.2202L18.7407 10.266L18.9915 15.7358L19.9904 15.69L19.7397 10.2202Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6959 10.5597L17.6975 10.6162L17.9483 15.0515L18.9467 14.9951L18.6959 10.5597Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6516 10.8919L16.6549 10.9737L16.9057 14.0297L17.9023 13.9479L17.6516 10.8919Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9734 15.3267L14.9986 15.1034L15.4112 13.3027L16.3859 13.526L15.9734 15.3267Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7195 15.3267L17.6943 15.1034L17.2817 13.3027L16.3069 13.526L16.7195 15.3267Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4722 15.3102H15.4722V13.5423H16.4722V15.3102Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6348 10.9133L15.6345 10.9378L15.5761 13.3187L14.5764 13.2942L14.6348 10.9133Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3739 10.9133L17.3736 10.9378L17.3152 13.3187L16.3155 13.2942L16.3739 10.9133Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.338 15.9228L13.5977 14.9572C14.6587 15.2425 15.4734 15.3836 16.029 15.3836C16.5845 15.3836 17.3993 15.2425 18.4603 14.9572L18.72 15.9228C17.5816 16.229 16.6889 16.3836 16.029 16.3836C15.3691 16.3836 14.4764 16.229 13.338 15.9228Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2823 10.2227C12.2157 9.56211 12.6023 9.11493 13.2576 9.17196C13.473 9.19072 13.715 9.25446 14.0373 9.36381C14.1315 9.39612 14.1315 9.39612 14.223 9.42852C14.6661 9.58611 14.7864 9.62662 14.8114 9.63196C14.7132 9.60972 15.0024 9.08695 15.0687 8.99884C15.0766 9.05479 15.0433 9.04683 14.9633 9.03083L14.0613 8.8503L14.7034 8.19155C14.9279 7.96129 15.2268 7.84711 15.5678 7.84711C15.6032 7.84711 15.6362 7.84546 15.7445 7.8388C15.8247 7.83392 15.8247 7.83392 15.9148 7.83019C16.5387 7.80998 16.9862 7.98642 16.9862 8.62807C16.9862 8.85763 17.0152 9.22678 17.0631 9.50683C17.0792 9.60103 17.1103 9.68921 17.0185 9.72794C17.0223 9.69452 17.2409 9.60828 17.5807 9.46615L17.6215 9.4491C18.609 9.03696 18.7243 8.99872 19.0426 9.19217C19.2547 9.32108 19.4567 9.55295 19.683 9.89866L18.8463 10.4464C18.7004 10.2234 18.5841 10.0881 18.5288 10.0503C18.6546 10.1377 18.2309 10.2784 18.0067 10.3719L17.9666 10.3887C17.1978 10.7102 17.0964 10.7486 16.8766 10.7486C16.2784 10.7486 16.0636 10.1358 16.0048 9.25828C15.8202 9.86586 15.2696 10.6326 14.8158 10.6326C14.6172 10.6326 14.7127 10.664 13.8879 10.3707C13.8015 10.3401 13.8015 10.3401 13.716 10.3108C13.4662 10.226 13.2859 10.1785 13.1722 10.1683C13.1769 10.163 13.1936 10.1449 13.2124 10.1288L12.2823 10.2227Z",
    fill: "#C09302"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg);
export default __webpack_public_path__ + "static/media/EG.025b8b48bf32e7bdbb19a2b757d8ad0a.svg";
export { ForwardRef as ReactComponent };